export function formatDollarInputValue(raw: string): string {
  const cleaned = raw.replace(/[$,\s]/g, '').replace(/[^0-9.]/g, '');
  if (cleaned === '') {
    return '';
  }

  const dotIndex = cleaned.indexOf('.');
  const hasDecimal = dotIndex !== -1;
  const integerRaw = hasDecimal ? cleaned.slice(0, dotIndex) : cleaned;
  const fractionalRaw = hasDecimal ? cleaned.slice(dotIndex + 1).replace(/\./g, '') : '';

  const integerFormatted = integerRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (!hasDecimal) {
    return integerFormatted;
  }

  return `${integerFormatted}.${fractionalRaw.slice(0, 2)}`;
}

export function formatDollarInputValueWithCaret(raw: string, caret: number): { value: string; caret: number } {
  const clampedCaret = Math.max(0, Math.min(caret, raw.length));
  return {
    value: formatDollarInputValue(raw),
    caret: formatDollarInputValue(raw.slice(0, clampedCaret)).length
  };
}
